import React, { Component } from 'react';
import Modal from './Modal';
import check from "../../assets/check.svg";
import equis from "../../assets/eliminar.svg";
import '../../css/FormAcuerdoAdmisiones.css';
import Header from './Header.js';
import Footer from './Footer.js';
import anuncioico from "../../assets/AnuncioICO.svg";
import alarma from "../../assets/alarma.svg";
import AcuerdoAdmisiones from './AcuerdoAdmisiones.js';
import jwt from 'jwt-decode'
import axios from "axios";

export class FormAcuerdoAdmisiones extends Component {
    constructor(props) {
        super(props);
        this.state = {
            IsFirmado: false,
            modalError: false,
            isPersonalData: false,
            activebutton: true,
            modalIngresoDatos: false,
            aceptoAcuerdo: false,
            modalPrevAcuerdoGen: false,
            modalIsOpen: false,
            verBoton: true,
             datosUsuario: {
                token: "",
                id: "",
                identificacion: "0",
                alias_sugerido: "",
                telefono: "",
                unidad: "",
                rol: "",
                correoAlterno: "",
                nombres: "",
                apellidos: "",
                username: "",
                correo: "",
                usuarioEscogido: "",
                fechaNacimiento:""
            },
            navigateCas: false // Cambiado a false para mostrar el formulario directamente
        };
        
        // Bind de métodos
        this.cerrarModalError = this.cerrarModalError.bind(this);
        this.abrirModalError = this.abrirModalError.bind(this);
    }

    cerrarModalError() {
        this.setState({
            modalError: false
        });
    }

    abrirModalError() {
        this.setState({
            modalError: true
        });
    }

     componentWillMount = () => {
        this.validarToken();
    }

    validarToken () {
        var ruta = window.location.href;
        //console.log("la ruta es: "+ ruta);
        try {
            if (ruta.split("token=")[1] === undefined) {
                window.location.href = "/Inicio";
            } else {
                //console.log("si tiene token");
                var token = ruta.split("token=")[1];
                //console.log("el token es: " + token);
                this.state.datosUsuario.token = token;
                var tokendecode = jwt(token);
                //console.log(tokendecode);
                var exp = tokendecode["exp"];
                this.state.datosUsuario.nombres = tokendecode["Nombres"];
                this.state.datosUsuario.apellidos = tokendecode["Apellidos"];
                this.state.datosUsuario.identificacion = tokendecode["Identificacion"];
                var fe1 = new Date(exp * 1000);
                var fe2 = new Date();
                if (fe1 < fe2) {
                    window.location.href = "/Inicio";
                };

                //validar que no haya firmado el acuerdo
                this.setState({ navigateCas: false }, () => {
                    this.validarfirma(tokendecode["Identificacion"]);
                });

            }
        } catch (exception){
            this.setState({ navigateCas: true });
        }  
    };
    validarfirma(identificacion) {
        //console.log(identificacion);
    axios.get(`${process.env.REACT_APP_API}api/PersonaDago/IsAgreementSign/${identificacion}`)
            .then(resp => {
                //console.log(resp.data.data);
                if (resp.data.data.Aceptodatospers == "si" && resp.data.data.estado == "1") {
                    this.setState({ IsFirmado: true });
                }
                //this.activebuttonf1();
                //this.abrirModalNoAcepACGeneralPrev();
            }).catch(error => {
                /*this.setState({
                    modalErrorAcuerdoGen: {
                        show: true,
                        titulo: "Error al guardar el registro de la firma",
                        mensaje: error.response.data,
                        imagen: equis,
                    }
                });
                this.activebuttonf1();*/
            })
    }


    render() {
        return (
            !this.state.navigateCas ?
                this.state.IsFirmado ?
                    (<Modal isOpen={this.state.modalNoExisteEnBase} cerrarModal={this.cerrarModalnoExisteEnBase} verBoton={false} textoBoton="ACEPTAR" >
                        <div className='mt-6 mb-6 nacionalidad-modalnocuenta-div' align="center">
                            <img className="nacionalidad-modalnocuenta-logos" src={alarma} alt="Error"></img>
                        </div>
                        <p className='text-center nacionalidad-modalnocuenta-texto '>Estimado usuario, usted ya ha firmado el <b>acuerdo de tratamiento de datos personales</b> para aspirantes a estudiantes de la ESPOL.</p>
                        <p className="text-center">
                            <strong>En el caso de existir un error, puede comunicarse con la unidad de Admisiones ESPOL.</strong></p>
                        <div className="text-center inactiva-contacto">
                            <table>
                                <tr>
                                    <td><strong>Atención: </strong></td>
                                    <td className="nacionalidad-centerTable">Lunes a Viernes de 08:30 a 16:00</td>
                                </tr>
                                <tr>
                                    <td><strong>Correo: </strong></td>
                                    <td className="nacionalidad-centerTable"><a href="mailto:admision@espol.edu.ec" >admision@espol.edu.ec</a></td>
                                </tr>
                            </table>
                        </div>
                    </Modal>)
                    :
                    (<AcuerdoAdmisiones
                        identificacion={this.state.datosUsuario.identificacion}
                        nombres={this.state.datosUsuario.nombres}
                        apellidos={this.state.datosUsuario.apellidos}
                        alias_sugerido={this.state.datosUsuario.alias_sugerido}
                        usuario_sugerido={this.state.datosUsuario.username}
                        correoAlterno={this.state.datosUsuario.correo}
                        tipoForm={"A"}
                        mensaje_titulo="Firma de acuerdo"
                        firmadoGeneral={true}
                        tipoAcuerdo={"ALUMNI"}
                        modalPrevAcuerdoGen={false}
                    />)
                :
                this.state.modalError &&
                    <Modal isOpen={this.state.modalError} cerrarModal={this.cerrarModalError} verBoton={true} textoBoton="ACEPTAR" >
                        <p className='text-center'><strong>Error al cargar el acuerdo de admisiones ESPOL</strong></p>
                        <div align="center">
                            <img className="registroContra-check" src={equis} alt="Error"></img>
                        </div>
                        <p className='text-center'>Existe un problema en el token generado.</p>
                    </Modal>
        );
    }
}

export default FormAcuerdoAdmisiones;
